module.exports = __webpack_public_path__ + "img/四川省.a2bb4354.png";